import {
  ButtonComponent,
  VxlButtonHorizontalLayout,
} from '@varo/graphql-schema-types';
import React from 'react';
import Button from 'shared/components/vxl/Button/Button';

interface VXLButtonProps {
  component: ButtonComponent;
  onPress: () => void;
}
export const VXLButton = ({ component, onPress }: VXLButtonProps) => {
  const { button } = component;
  const {
    copy: styledCopy,
    verticalLayout,
    style,
    isEnabled,
    horizontalLayout,
  } = button;
  const { copy } = styledCopy;

  const width =
    horizontalLayout === VxlButtonHorizontalLayout.Full
      ? VxlButtonHorizontalLayout.Full
      : 'HUG';

  return (
    <Button
      label={copy}
      isDisabled={!isEnabled}
      size={verticalLayout}
      onPress={onPress}
      type={style}
      width={width}
    />
  );
};
